var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper"},[_c('div',{staticClass:"fixed-header"},[_c('Header')],1),_c('div',{staticClass:"main-container"},[_c('side-bar'),_c('app-main')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }